module.exports = __webpack_public_path__ + "images/_/programs/epsIntermediates/images/characters/sara_twist_hands_out_yay-bcf1fb30eda8e0aa404ef594e2dd3fd6.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsIntermediates/images/characters/sara_twist_hands_out_yay.png
// module id = 2322
// module chunks = 2